var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-radio-group',{on:{"change":_vm.getsctType},model:{value:(_vm.radio),callback:function ($$v) {_vm.radio=$$v},expression:"radio"}},[_c('el-radio',{attrs:{"label":0}},[_vm._v("选修")]),_c('el-radio',{attrs:{"label":1}},[_vm._v("必修")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }